<template>
  <div id="header" :class="{'unstuck': unstuck}">
    <CookieBanner
      :class="{'unstuck': unstuck}"
      @cookieBanner="handleCookieBanner"
    />
    <header :class="{ header: true, bump: cookieBannerOpen, 'unstuck': unstuck }">
      <img class="header-logo" src="../assets/images/logo@2x.png" alt="logo">
    </header>
  </div>
</template>

<script>
import CookieBanner from './CookieBanner.vue';

export default {
  components: { CookieBanner },

  data () {
    return {
      cookieBannerOpen: false,
      unstuck: false
    }
  },

  methods: {
    handleCookieBanner (state) {
      this.cookieBannerOpen = state === 'open';
    },

    stickyHeaderHandler() {
      const headerHeight = document.querySelector('.cookie-policy-bar').offsetHeight + document.querySelector('.header').offsetHeight;
      const headerCoverage = headerHeight / window.innerHeight * 100;
      this.unstuck = headerCoverage >= 25 ? true : false;
    }
  },

  mounted() {
    this.stickyHeaderHandler();
    window.addEventListener('resize', this.stickyHeaderHandler);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.stickyHeaderHandler);
  },
}
</script>


<style lang="scss">
  #header.unstuck {
    margin-bottom: -65px;
  }

  .header {
    background-color: #353d42;
    height: 65px;
    position: fixed;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 100;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .header.bump {
    top: 111px;
    @media (min-width: 428px) {
      top: 91px;
    }
    @media (min-width: 576px) {
      top: 75px;
    }
    @media (min-width: 768px) {
      top: 55px;
    }
    @media (min-width: 1200px) {
      top: 35px;
    }
  }

  .header.unstuck {
    position: static;
  }

  .header-logo {
    max-width: 100%;
    width: 556px;
    padding: 0 33px;
  }
</style>





// WEBPACK FOOTER //
// src/components/Header.vue